import React from "react";
import { SelectEventObject } from "highcharts";

export const selectedLegendItems = (serie: Highcharts.Series, currentLegend: number[]): void => {
    if (!currentLegend.includes(serie.index)) currentLegend.push(serie.index);
    else currentLegend.splice(currentLegend.indexOf(serie.index), 1);
};

export const toggleAxisVisibility = (
    ev: SelectEventObject,
    setTitlesVisible: React.Dispatch<React.SetStateAction<boolean>>
): void => {
    if (ev.xAxis) {
        setTitlesVisible(false);
    } else {
        setTitlesVisible(true);
    }
};

/**
 * Gets a radius proportional to chart dimensions (only for cartesian plane like charts)
 * @param {number} chartWidth - The dimension of the chart
 * @param {number} radius - The radius for the circle
 * @returns {number} - The radius for the circle
 */
export const getProportionalRadius = (chartWidth: number, radius: number) => {
    return chartWidth * (radius / 2 / 100);
};
